//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex'
import store from '@/store'
function orientationChange () {
  store.commit('set_isTrans', window.orientation)
  switch (window.orientation) {
    case 0:
      console.log('肖像模式 0,screen-width: ' + screen.width + '; screen-height:' + screen.height)
      break
    case -90:
      console.log('左旋 -90,screen-width: ' + screen.width + '; screen-height:' + screen.height)
      break
    case 90:
      console.log('右旋 90,screen-width: ' + screen.width + '; screen-height:' + screen.height)
      break
    case 180:
      console.log('风景模式 180,screen-width: ' + screen.width + '; screen-height:' + screen.height)
      break
  };
};

export default {
  name: 'App',
  computed: mapState({
    nowDate: state => state.isTrans.nowDate,
    timeDifference: state => state.isTrans.timeDifference,
    commonTime: state => state.common.time,
    questions_time: state => state.common.questions_time,
    timer_bol: state => state.common.timer_bol,
    loading: state => state.common.loading,
    isTrans: state => state.common.isTrans
  }),
  data () {
    return {
      imgBol: false,
      bol: true,
      timer: null,             // 加载动画定时器
      timerBol: false,         // 是否开过定时器
      questionsTimer: null     // 试卷时间定时器
    }
  },
  methods: {
    ...mapMutations([
      'set_nowDate',
      'set_isTrans',
      'common_time',
      'common_questions_time',
      'set_questions_time',
      'common_timer_bol',
      'common_isMiniProgram'
    ])
  },
  created () {
    setInterval(() => {
      let num = new Date().getTime()
      this.common_time(num)
    }, 1000)
  },
  mounted () {
    let time = new Date().getTime() + this.timeDifference
    this.set_nowDate(time)
    setInterval(() => {
      time = new Date().getTime() + this.timeDifference
      this.set_nowDate(time)
    }, 1000)
    // 添加事件监听
    addEventListener('load', function () {
      orientationChange()
      window.onorientationchange = orientationChange
      // this.set_isTrans(window.orientation)

      store.commit('set_isTrans', window.orientation)
      console.log(11111111111, store.state.isTrans, window.orientation)
    })
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual' // 改为manual之后，就不会记录滚动位置
    }
    if (/micromessenger/.test(navigator.userAgent.toLowerCase())) {
      window.wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          this.common_isMiniProgram(true)
        } else {
          this.common_isMiniProgram(false)
        }
      })
    } else {
      this.common_isMiniProgram(false)
    }
    if (!this.$route.query.language) {
      let lang = (navigator.language || navigator.browserLanguage).toLowerCase()
      let language = 'en'
      if (lang.indexOf('zh') !== -1) {
        // 浏览器语言是中文
        language = 'zh'
      }
      this.$i18n.locale = this.$utils.cache('blh5:lang') ? this.$utils.cache('blh5:lang') : language
      this.$utils.cache('blh5:lang', this.$i18n.locale)
    }
  },
  watch: {
    'timeDifference' () {
      let time = new Date().getTime() + this.timeDifference
      this.set_nowDate(time)
      this.$nextTick(() => {
        if (this.$route.query.language) {
          console.log(this.$route.query.language)
          this.$i18n.locale = this.$route.query.language
          this.$utils.cache('blh5:lang', this.$route.query.language)
          if (this.$utils.cache('blh5:lang')) {
            this.$router.replace({
              path: this.$route.path,
              query: {...this.$route.query, language: ''}
            })
          }
        }
      })
      console.log(888888888, time)
    },
    'loading' () {
      if (this.loading && !this.timerBol) {
        this.timerBol = true
        this.timer = setTimeout(() => {
          this.imgBol = true
        }, 1000)
      } else {
        clearTimeout(this.timer)
        this.timerBol = false
        this.imgBol = false
      }
    },
    // 监听考试时间开启定时器功能，吃香为时间计时器
    timer_bol () {
      if (this.timer_bol) {
        this.questionsTimer = setInterval(() => {
          this.common_questions_time(1000)
          if (this.questions_time <= 0) {
            clearInterval(this.questionsTimer)
            this.set_questions_time(null)
            this.common_timer_bol(false)
          }
        }, 1000)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue